import { APP_ROUTES } from '@/routes';
import type { ForgotPasswordFormType } from '../schemas';
import { useAuthMutations } from './mutations';
import { useRouter } from 'next/navigation';
import { useToast } from '@packages/chakra-v3';

const useForgotPassword = () => {
	const router = useRouter();
	const { forgotPasswordMutation } = useAuthMutations();
	const { showSuccess } = useToast();

	const handleOnBack = () => router.back();
	const handleForgotPasswordSuccess = () => {
		router.push(APP_ROUTES.AUTH.LOGIN);
		showSuccess({
			title:       'Password reset email sent',
			description: 'Please check your email for further instructions',
		});
	};

	const handleForgotPassword = async({ email }: ForgotPasswordFormType) => {
		await forgotPasswordMutation.mutateAsync(
			{ body: { email } },
			{ onSuccess: handleForgotPasswordSuccess  },
		);
	};

	return {
		handleForgotPassword,
		handleOnBack,
	};
};

export default useForgotPassword;